
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'Stepper'
})
export default class extends Vue {
  @Prop({ default: '' }) value!: number;

  @Prop({ default: 1 }) minNum!: number;

  @Prop({ default: Infinity }) max!: number;

  @Prop({ default: false }) readonly!: Boolean;

  num: number = this.value; // 所选商品数量

  get isGray(): boolean {
    return this.num === 1;
  }

  reduce() {
    if (this.num !== 1 && !this.isGray && !this.readonly) {
      this.num -= 1;
      this.$emit('update:value', this.num);
      this.$emit('change', this.num);
      this.$emit('reduce', this.num);
    }
  }

  add() {
    if ((this.num <= this.max) && !this.readonly) {
      this.num += 1;
      this.$emit('update:value', this.num);
      this.$emit('change', this.num);
      this.$emit('add', this.num);
    }
  }

  numchange(e:any) {
    let v = e.target.value;
    if (v > this.max) v = this.max;
    if (v < this.minNum) v = this.minNum;
    this.num = v;
    this.$emit('update:value', this.num);
    this.$emit('change', this.num);
    this.$emit('numchange', this.num);
  }
}
